import { render } from "./TableCardHeader.vue?vue&type=template&id=30515046&scoped=true"
import script from "./TableCardHeader.vue?vue&type=script&lang=js"
export * from "./TableCardHeader.vue?vue&type=script&lang=js"

import "./TableCardHeader.vue?vue&type=style&index=0&id=30515046&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30515046"]])

export default __exports__